class SsoResolutionDto {

    IsSso: boolean;
    DomainHint: string;

    constructor(isSso: boolean, domainHint: string) {
        this.IsSso = isSso;
        this.DomainHint = domainHint;
    }
}

export default SsoResolutionDto;
